import { CCol, CModal, CModalBody, CModalHeader, CModalTitle, CRow } from "@coreui/react"
import React, { useEffect, useState } from "react"
import ChannelList from "./ChannelList"
import styled from 'styled-components';
import CIcon from "@coreui/icons-react";
import { cilX } from "@coreui/icons";

const SelectBox = styled.div`
  cursor: pointer
`;

const Placeholder = styled.div`
  color: #8b93a2
`;

const SelectChannel = (props) => {
  const [modal, setModal] = useState(false)
  const [value, setValue] = useState('')

  useEffect(()=>{
    setValue(props.value?props.value:'')
  }, [props.value])

  return(
    <div>
      <SelectBox>
        <div className="form-select">
          <CRow>
            <CCol>
              <div onClick={()=>setModal(true)}>
                {
                  value===''?(
                    <Placeholder>
                      Select Channel
                    </Placeholder>
                  ):(
                    <div>{value.channel_name}</div>
                  )
                }
              </div>
            </CCol>
            {
              value!=="" &&
              <CCol xs={'auto'}>
                <div className="me-2" onClick={()=>{
                  setValue('')
                  props.onSelect('')
                }}>
                  <CIcon icon={cilX}/>
                </div>
              </CCol>
            }
          </CRow>
        </div>
      </SelectBox>

      <CModal
        alignment="center"
        size="lg"
        visible={modal}
        onClose={() => setModal(false) }
      >
        <CModalHeader>
          <CModalTitle>Select Channel</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <ChannelList
            value={value===''?{}:value}
            onSelect={(data)=>{
              setValue(data)
              setModal(false)
              props.onSelect(data)
            }}
          />
        </CModalBody>
      </CModal>
    </div>
  )
}

export default SelectChannel